import React from "react";
import AboutNavBar from "../components/AboutNavBar";
// import BlockChainServiceDetails from '../components/BlockChainServiceDetails'
// import BlockChainServicesContent from '../components/BlockChainServicesContent'
import Blog from "../components/Blog";
import Footer from "../components/Footer";
import RenderLinks from "../components/RenderLinks";
import { Helmet } from "react-helmet-async";

function Blogs() {
  const siteUrl = "https://microcodesoftware.com"; // Base URL
  const pagePath = "/blog"; // Dynamic path if needed
  return (
    <div>
      <Helmet>
        <title>
          Latest Tech Insights & Software Updates | Microcode Software Blog
        </title>
        <meta
          name="description"
          content="Stay ahead with Microcode Software’s blog—featuring expert insights, software development trends, digital transformation tips, and the latest tech news to empower your business."
        />
        <meta
          name="keywords"
          content="Microcode Software blog, Software development, Tech news, Digital transformation, Programming tutorials, Software updates, IT solutions, Coding tips, Software engineering insights"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`${siteUrl}${pagePath}`} />
      </Helmet>
      <RenderLinks />
      <AboutNavBar />
      <Blog />
      {/* <BlockChainServiceDetails/> */}
      {/* <BlockChainServicesContent/> */}
      <Footer />
    </div>
  );
}

export default Blogs;
